import { render, staticRenderFns } from "./AppPhoneNo.vue?vue&type=template&id=24372452&"
import script from "./AppPhoneNo.vue?vue&type=script&lang=ts&"
export * from "./AppPhoneNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports